import { GetLocaleDisplayName, Locale } from '../interface';

export const createGetLocaleDisplayName =
  (locales: Locale[]): GetLocaleDisplayName =>
  (key: string) => {
    const locale = locales.find(locale => locale.key === key);
    return locale ? locale.name : key;
  };
